import "./img_1.css";
function Img_1() {
  return (
    <>
     
        <div className="middlecnt_background mt-5">
          <div className=" Middle">
            <h1 className="mt-3 middle_txt">You Got A Game, We You</h1>
            <h1 className="mb-3 middle_txt1">Covered.</h1>
            <h1 className="mt-3 middle_txt2">Book Through Enturf And </h1>
            <h1 className="mb-3 middle_txt3"> Unlock Your Reality Virtually.</h1>
          </div>
        </div>
   
    </>
  );
}

export default Img_1;
